import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {Empty, Button, Image} from 'antd';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TallyPng from '@Images/admin/integrations/tally.png';
import TallyConnectionList from '../TallyConnectionList';
import './style.scss';
import '../../../../../scss/integration.scss'

/**
 *
 */
function TallyHome({
  getTallyConnections, user, getTallyConnectionsLoading, tallyConnections, history,
}) {
  const [isUserAllReadyConnected, setIsUserAllReadyConnected] = React.useState(false);

  useEffect(() => {
    getTallyConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    // const hasActiveConnection = tallyConnections?.find((connection) => connection?.is_active);
    if (tallyConnections?.filter((item) => item)?.length > 0) {
      setIsUserAllReadyConnected(true);
    } else {
      setIsUserAllReadyConnected(false);
    }
  }, [tallyConnections]);

  return (
    <div className="integration-home__wrapper">
      <div className="integration-home__header">
        <div className="flex-display flex-align-c">
          <Image src={TallyPng} className="integration-home__heading"  preview={false} />
          &nbsp;
          Tally Accounting
        </div>
        <Button
          type="primary"
          disabled={getTallyConnectionsLoading}
          onClick={() => {
            const id = 'new Account';
            history.push('/admin/integration/tally/setup?is_create_flow=true', { id });
          }}
        >
          + New Connection
        </Button>
      </div>

      { !getTallyConnectionsLoading ? (
        <React.Fragment>
          {isUserAllReadyConnected === true && (
            <React.Fragment>
              <TallyConnectionList callback={() => setIsUserAllReadyConnected(false)} />
            </React.Fragment>

          )}
          {isUserAllReadyConnected === false
            && (
              <React.Fragment>
                <div className="integration-empty-state__wrapper">
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description=""
                  />
                  <p className="integration-empty-state__heading">Your Procuzy account is not yet connected to tally</p>
                    <Button
                      type="primary"
                      onClick={() => {
                        history.push('/admin/integration/tally/setup');
                      }}
                      loading={getTallyConnectionsLoading}
                      disabled={getTallyConnectionsLoading}
                    >
                      Connect Now
                    </Button>
                </div>
              </React.Fragment>
            )}

        </React.Fragment>
      ) : (
        <div className="integration-home__wrapper">
          {
            [1, 2].map((item) => (
              <div
                key={item}
                className="integration-card__loading"
              >
                <div className="tally-card-spacing">
                  <div className="tally-card-header ">
                    <div className="loadingBlock integration-card__loading__header-text" />
                    <div className="loadingBlock integration-card__loading__header-image"> </div>
                  </div>
                  <div className="integration-card__loading__link" />
                  <div className="integration-card__loading__footer" />
                </div>
              </div>
            ))
          }
        </div>
      ) }
    </div>
  );
}

const mapStateToProps = ({ TallyIntegrationReducers, UserReducers }) => ({
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  getTallyConnectionsLoading: TallyIntegrationReducers.getTallyConnectionsLoading,
  user: UserReducers.user,
});
const mapDispatchToProps = (dispatch) => ({
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  connectToTally: (orgId, callback) => dispatch(TallyIntegrationActions.connectToTally(orgId, callback)),

});
TallyHome.propTypes = {
  user: PropTypes.any,
  tallyConnections: PropTypes.any,
  history: PropTypes.any,
  getTallyConnections: PropTypes.func,
  getTallyConnectionsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyHome));
